import React from "react";

export default function SQL_Data_Types() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Data_Types</h1>
      <p>This is the SQL_Data_Types component generated from the SQL JSON.</p>
    </div>
  );
}
